var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getShiftPositionsForVolunteerFunctionDef, } from '../../../../../backend/features/shift/shared';
import { getParticipationStatus } from '../../../../../backend/utils/shiftStateUtils';
import { NoShifts } from '../../../../../ui/components/NoShifts';
import { PageToolbar } from '../../../../../ui/components/PageToolbar';
import { ShiftRemainingTime } from '../../../../../ui/components/ShiftRemainingTime';
import { Slots } from '../../../../../ui/components/Slots';
import { Shift } from '../../../../../ui/features/mission-details/components/Shift';
import { useMissionsTranslation } from '../../../../../ui/hooks';
import { showFormDialog } from '@juvare/common-form-ui/showFormDialog';
import { showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useUserState } from '@juvare/contact-management/ui/hooks';
import { getSettings } from '@juvare/platform-sdk-react/ui/features/editable-settings';
import { useTypedPlatformFunction } from '@juvare/platform-sdk-react/ui/features/typed-platform-functions';
import { Box } from '@mui/material';
import { hoursToMilliseconds } from 'date-fns';
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { getParticipationStatusBadgeLabel } from '../../utils';
import { ShiftDetailsVolunteerActions } from '../shift-details-actions';
import { ShiftDetailsTablesVolunteer } from '../shift-details-tables';
export const UpcomingShiftsVolunteer = ({ shifts, missionStatus, onFetchShifts, onSelfWithdrawal, onRequestParticipation, }) => {
    const { t } = useMissionsTranslation();
    const { id: currentUserId } = useUserState();
    const getShiftPositionsForVolunteerPlatformFn = useTypedPlatformFunction(getShiftPositionsForVolunteerFunctionDef);
    const settings = useSelector(getSettings);
    // TODO: Remove Omit - CRMS-3034
    const getShiftPositionsForVolunteer = (shiftId) => __awaiter(void 0, void 0, void 0, function* () {
        const result = (yield getShiftPositionsForVolunteerPlatformFn({ shiftId })); // TODO: Remove Type Casting after PLAT-2704
        return result;
    });
    const handleRequestParticipation = (shiftId) => {
        const positions = getShiftPositionsForVolunteer(shiftId).then((positions) => positions.map((position) => ({ value: position.id, label: position.data.name })));
        showFormDialog({
            title: t('requestShift.title'),
            config: {
                type: 'form',
                children: [
                    {
                        type: 'form.panel',
                        children: [
                            {
                                type: 'form.content',
                                key: 'content',
                                html: '<p class="body1" style="color: #616161">Select the positions you want to be considered for on this shift.</p>',
                            },
                            {
                                type: 'form.multiSelect',
                                key: 'requestedPositions',
                                label: 'Position',
                                valueProvider: { custom: () => positions },
                                validate: {
                                    required: true,
                                },
                                selectAll: true,
                            },
                        ],
                    },
                    {
                        type: 'form.content',
                        html: `<p class="body1">${t('requestShift.description')}</p>`,
                    },
                    {
                        type: 'form.advancedRadio',
                        key: 'showContactInfo',
                        values: [
                            { value: true, label: t('requestShift.showContactInfo') },
                            { value: false, label: t('requestShift.hideContactInfo') },
                        ],
                        validate: {
                            required: true,
                        },
                    },
                ],
            },
            onSubmit: (_a) => __awaiter(void 0, [_a], void 0, function* ({ showContactInfo, requestedPositions }) {
                yield onRequestParticipation({ shiftId, showContactInfo, requestedPositions });
                yield onFetchShifts();
                showAlertSnackbar({
                    message: t('requestShift.requestSubmitted'),
                    autoHideDuration: 2000,
                    type: 'success',
                });
            }),
            submitLabel: t('requestShift.submitButtonText'),
        });
    };
    const handleWithdraw = (params) => __awaiter(void 0, void 0, void 0, function* () {
        yield onSelfWithdrawal(params);
        yield onFetchShifts();
    });
    if (shifts.length === 0) {
        return React.createElement(NoShifts, { description: t('missions.noUpcomingShiftsForMission') });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(PageToolbar, { title: t('shifts.upcomingShifts'), showTitle: missionStatus !== 'complete', count: shifts.length }),
        React.createElement(Box, { display: 'flex', flexDirection: 'column', sx: { gap: 2, pt: 2 }, role: 'list' }, shifts.map((shift, index) => (React.createElement(ShiftForUpcomingShiftsVolunteer, { key: shift.id, indexInList: index, shift: shift, currentUserId: currentUserId, onRequestParticipation: handleRequestParticipation, participantSelfWithdrawalTimeMs: hoursToMilliseconds(settings.allowSelfWithdrawalTime.time), onParticipantSelfWithdrawal: (params) => handleWithdraw(params) }))))));
};
const ShiftForUpcomingShiftsVolunteer = ({ shift, currentUserId, onRequestParticipation, onParticipantSelfWithdrawal, participantSelfWithdrawalTimeMs, indexInList, }) => {
    const { t } = useMissionsTranslation();
    const handleWithdraw = useCallback(() => onParticipantSelfWithdrawal({
        shiftId: shift.id,
        participantId: currentUserId,
        withdrawalAllowedTimeMs: participantSelfWithdrawalTimeMs,
        shiftStartTimeMs: shift.columns.startTime,
    }), [onParticipantSelfWithdrawal, shift.id, shift.columns.startTime, currentUserId, participantSelfWithdrawalTimeMs]);
    const renderParticipantsTable = useCallback((participants) => (React.createElement(ShiftDetailsTablesVolunteer, { shift: shift, participants: participants })), [shift]);
    return (React.createElement(Shift, { shift: shift, location: 'missions', allowMissionChange: false, indexInList: indexInList, renderParticipantsTable: renderParticipantsTable, statusBadgeLabel: getParticipationStatusBadgeLabel(t, getParticipationStatus(shift.userParticipations)), showShiftDetailsCardToggle: false, analyticsComponent: React.createElement(Slots, { total: shift.columns.totalParticipantSlots, totalApproved: shift.analytics.totalApprovedParticipants }), actionsComponent: React.createElement(Box, { sx: {
                display: 'flex',
                justifyContent: { xs: 'space-between', lg: 'flex-end' },
                alignItems: 'center',
                ml: { xs: 'unset', lg: 'auto' },
                gap: 2,
                width: { xs: '100%', lg: 'auto' },
            } },
            React.createElement(ShiftRemainingTime, { startTime: shift.columns.startTime }),
            React.createElement(ShiftDetailsVolunteerActions, { onRequest: () => onRequestParticipation(shift.id), onParticipantSelfWithdrawal: handleWithdraw, participationStatus: getParticipationStatus(shift.userParticipations), shiftStopTime: shift.columns.stopTime, shiftStartTime: shift.columns.startTime })) }));
};
